import {
  component as ComponentContext,
  vertical as VerticalContext,
} from '@cred/react-analytics/contexts'

const setComponentContext = (component) => ComponentContext.analytics(component)

const setVerticalContext = (vertical) => VerticalContext.analytics(vertical)

const verticalContext = setVerticalContext({ name: 'personal-loan' })
const savingsCalculatorContext = [
  setComponentContext({ name: 'Savings calculator widget' }),
  verticalContext,
]
const savingsCalculatorDisclosureModalContext = [
  setComponentContext({ name: 'Savings Calculator Widget Disclosure Modal' }),
  verticalContext,
]

export { savingsCalculatorContext, savingsCalculatorDisclosureModalContext }
